import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { IoSearchSharp, IoNewspaperOutline } from 'react-icons/io5';
import { BiSolidEditAlt } from 'react-icons/bi';
import { CiEdit } from 'react-icons/ci';
import { LuDelete } from 'react-icons/lu';
import { TiDeleteOutline, TiTick } from 'react-icons/ti';
import { FaRegWindowClose, FaUserEdit } from 'react-icons/fa';
import { DataContext } from '../context/DataProvider';
import { Link, useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { RiLockPasswordLine } from 'react-icons/ri';

// import delete from '../images/icons/delete.png'
const UsersManagment = () => {
  const {
    userInfo,
    expire,
    expireToken,
    tokenLogin,
    fetchRefreshToken,
    isTokenExpired,
    edame,
    OptionSearch,
    setOption,
    Register,
    username,
    setUserName,
  } = useContext(DataContext);
  const [searchParams, setsearchParams] = useSearchParams();
  const page: any = searchParams.get('page');
  const [UserList, setUserList] = useState([]);
  const [lisUsercutorcount, setLisUsercutorcount] = useState(0);
  const [SearchPage, setSearchPage] = useState(1);
  const [SearchResult, setSearchResult] = useState([]);
  const [editcase, setEditCase] = useState({
    firstName: '',
    lastName: '',
    ID: 0,
    email: '',
    Username: '',
    // phoneNumber: 0,
    // code: 0,
    // education: '',
    // degree: '',
    // role: '',
    Password: '',
    confirmPassword: '',
    // place: '',
  });

  const [SearchResultcount, setSearchResultcount] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [isLoading, setisLoading] = useState(true);
  const [EditModal, setOpenEditModal] = useState(false);
  const [CreateModal, setOpenCreateModal] = useState(false);
  const FetchListUser = async () => {
    await fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/Accounts/UserList?size=${pageSize}&page=${page == null ? 1 : page}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => setUserList(data))
      .finally(() => setisLoading(false));
  };

  useEffect(() => {
    FetchListUser();
  }, [pageSize]);

  console.log(UserList);
  if (tokenLogin == '') {
    window.location.assign('/');
    localStorage.clear();
  }
  return (
    <>
      <Breadcrumb pageName="مدیریت کاربران" />
      <div className="w-full max-w-full font-IranSans p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full flex items-center justify-between">
          <div className="w-full flex items-center">
            <input
              className="border-2 w-[45%] font-IranSans relative border-[#E5E1DA] outline-none p-1 rounded-lg m-8 text-[16px]"
              placeholder="جستجوی کاربر"
            />

            <button className="buttonsearch">
              <IoSearchSharp size={35} className="svgIcon" />
            </button>
          </div>
          <div>
            <button
              className=" w-full md:mt-0 mt-3 "
              onClick={() => setOpenCreateModal(true)}
            >
              <span className="boxUSer font-IranSans text-[16px] w-full">
                {' '}
                کاربر جدید
              </span>
            </button>
          </div>
        </div>
        <div className="w-full  overflow-y-auto">
          <table className="overflow-auto w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  نام و نام خانوادگی
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  نام کاربری
                </th>
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  ایمیل
                </th>
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  کد ملی
                </th>
                <th className="w-20 border-b p-3 text-[14px] text-center">
                  شماره همراه
                </th>
                <th className="w-32 border-b p-3 text-[14px] text-center">
                  تحصیلات و مدرک تحصیلی
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  نقش کاربری
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  محل خدمت{' '}
                </th>
                {/* <th className="w-5 border-b p-3 text-[14px] text-center">
                  ویرایش
                </th> */}
              </tr>
            </thead>
            <tbody>
              {UserList.map((item) => {
                return (
                  <>
                    <tr
                      className="cursor-pointer"
                      onClick={() => {
                        setEditCase({
                          firstName: item.firstName,
                          lastName: item.lastName,
                          ID: item.Id,
                          Username: item.UserName,
                          email: item.Email,
                        });

                        setOpenEditModal(true);
                      }}
                    >
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.firstName + '  ' + item.lastName}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.UserName}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {item.Email}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {/* {item.Email} */}
                      </td>{' '}
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {/* {item.Email} */}
                      </td>{' '}
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {/* {item.Email} */}
                      </td>{' '}
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {/* {item.Email} */}
                      </td>
                      <td className="w-20 border-b p-3 text-[14px] text-center">
                        {/* {item.Email} */}
                      </td>
                      {/* <td className="w-20 border-b p-3 text-[14px] text-center">
                        <span className="font-medium text-black dark:text-white flex items-center justify-center">
                          <button className="edit-button">
                            <BiSolidEditAlt
                              size={35}
                              className="edit-svgIcon"
                            />
                          </button>
                        </span>
                      </td> */}
                    </tr>
                    {/* </Link> */}
                  </>
                );
              })}

              {/* <td className="w-20 border-b p-3 text-[14px] text-center">1</td>
                <td className="w-20 border-b p-3 text-[14px] text-center">1</td>
                <td className="w-20 border-b p-3 text-[14px] text-center">1</td>
                <td className="w-20 border-b p-3 text-[14px] text-center">1</td> */}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel={<span className="mr-4 sm:mr-0">...</span>}
          nextLabel={
            <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-1">
              <BsChevronLeft />
            </span>
          }
          // onPageChange={ChangePage}
          pageRangeDisplayed={5}
          pageCount={5}
          // pageCount={Math.ceil(SearchListCount / 20)}
          previousLabel={
            <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
              <BsChevronRight />
            </span>
          }
          // initialPage={savePage - 1}
          containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
          pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
          // activeClassName={
          //   savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
          // }
          // current
        />
        {EditModal && (
          <div className="ModalBackground">
            <div className="Modal-innerEditUser">
              <FaRegWindowClose
                onClick={() => setOpenEditModal(false)}
                className="mb-2"
                size={20}
              />
              <div className="w-full h-[85%] border border-[#9ca3af] grid grid-cols-2 gap-3 px-3">
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">نام و نام خانوادگی:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    defaultValue={editcase.firstName + ' ' + editcase.lastName}
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">نام کاربری:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    defaultValue={editcase.Username}
                  />
                </div>
                <div className="w-full flex  items-center">
                  <span className="w-[30%]">ایمیل:</span>
                  <input
                    className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                    type="email"
                    defaultValue={editcase.email}
                  />
                </div>
                <div className="w-full flex  items-center ">
                  <span className="w-[30%]">کدملی:</span>
                  <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md" />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">شماره همراه:</span>
                  <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-lg" />
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">سطح تحصیلات :</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-lg">
                    <option></option>
                    <option>کارشناسی</option>
                    <option>کارشناسی ارشد</option>
                    <option>دکتری</option>
                  </select>
                </div>
                <div className="w-full flex items-center h-full">
                  <span className="w-[30%]">مدرک تحصیلی :</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-lg"></select>
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">نقش کاربری:</span>
                  <select className="border w-[70%] mr-3 p-1 rounded-lg"></select>
                </div>
                <div className="w-full flex  items-center h-full">
                  <span className="w-[30%]">محل خدمت:</span>
                  <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-lg" />
                </div>
              </div>
              <div className="flex  w-full ltr mt-3 mb-3 gap-3">
                <button
                  className="w-24 h-10 p-2 rounded-full text-[14px] text-white font-bold
                 bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  style={{ fontFamily: 'IranSans' }}
                >
                  حذف
                </button>
                <Link to="/changepasswordbysuperadmin">
                  <button
                    onClick={() =>
                      localStorage.setItem('username', editcase.Username)
                    }
                    className="w-32 h-10 p-2 rounded-full text-[14px] text-white flex items-center justify-center
                 bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                    style={{ fontFamily: 'IranSans' }}
                    // onClick={fetchEdit}
                  >
                    تغییر رمز عبور <RiLockPasswordLine className="ml-3" />
                  </button>
                </Link>
                <button
                  className="w-24 h-10 p-2 rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
                  hover:shadow-2xl hover:shadow-black "
                  style={{ fontFamily: 'IranSans' }}
                >
                  ثبت
                  <CiEdit size={20} className="ml-2" />
                </button>
              </div>
            </div>
          </div>
        )}
        {CreateModal && (
          <>
            <div className="ModalBackground">
              <div className="Modal-innerEditUser">
                <FaRegWindowClose
                  onClick={() => setOpenCreateModal(false)}
                  className="mb-2"
                  size={20}
                />
                <div className="w-full h-[85%] border border-[#9ca3af] grid grid-cols-2 gap-3 px-3">
                  <div className="w-full flex  items-center ">
                    <span className="w-[30%]">نام :</span>
                    <input
                      className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                      defaultValue={editcase.firstName}
                      onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          firstName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="w-full flex  items-center ">
                    <span className="w-[30%]">نام خانوادگی:</span>
                    <input
                      className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                      defaultValue={editcase.lastName}
                      onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          lastName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="w-full flex  items-center ">
                    <span className="w-[30%]">نام کاربری:</span>
                    <input
                      className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                      defaultValue={editcase.Username}
                      onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          Username: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="w-full flex  items-center ">
                    <span className="w-[30%]">رمز عبور:</span>
                    <input
                      type="password"
                      className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                      defaultValue={editcase.Password}
                      onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          Password: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="w-full flex  items-center ">
                    <span className="w-[30%]">تکرار رمز عبور :</span>
                    <input
                      type="password"
                      className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                      defaultValue={editcase.confirmPassword}
                      onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          confirmPassword: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="w-full flex  items-center">
                    <span className="w-[30%]">ایمیل:</span>
                    <input
                      className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"
                      type="email"
                      defaultValue={editcase.email}
                      onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          email: e.target.value,
                        }))
                      }
                    />
                  </div>
                  {/* <div className="w-full flex  items-center ">
                    <span className="w-[30%]">کدملی:</span>
                    <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-md"  onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          code:Number(e.target.value),
                        }))
                      }/>
                  </div> */}
                  {/* <div className="w-full flex  items-center h-full">
                    <span className="w-[30%]">شماره همراه:</span>
                    <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-lg" onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          phoneNumber:Number(e.target.value),
                        }))
                      } />
                  </div> */}
                  {/* <div className="w-full flex  items-center h-full">
                    <span className="w-[30%]">سطح تحصیلات :</span>
                    <select className="border w-[70%] mr-3 p-1 rounded-lg" onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          education:e.target.value,
                        }))
                      }>
                      <option></option>
                      <option>کارشناسی</option>
                      <option>کارشناسی ارشد</option>
                      <option>دکتری</option>
                    </select>
                  </div> */}
                  {/* <div className="w-full flex items-center h-full">
                    <span className="w-[30%]">مدرک تحصیلی :</span>
                    <select className="border w-[70%] mr-3 p-1 rounded-lg" onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          degree:e.target.value,
                        }))
                      }></select>
                  </div> */}
                  {/* <div className="w-full flex  items-center h-full">
                    <span className="w-[30%]">نقش کاربری:</span>
                    <select className="border w-[70%] mr-3 p-1 rounded-lg" onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          role:e.target.value,
                        }))
                      }></select>
                  </div> */}
                  {/* <div className="w-full flex  items-center h-full">
                    <span className="w-[30%]">محل خدمت:</span>
                    <input className="border mr-3 w-[70%] p-1 focus:outline-none rounded-lg" onChange={(e) =>
                        setEditCase((prevcase) => ({
                          ...prevcase,
                          place:e.target.value,
                        }))
                      } />
                  </div> */}
                </div>
                <div className="flex w-full ltr mt-3 mb-3 gap-1">
                  {/* <button
                  className="w-40 p-2 rounded-full text-[16px] text-white font-bold
                 bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  style={{ fontFamily: 'IranSans' }}
                >
                  حذف
                </button> */}
                  {/* <button
                      className="w-40 p-2 rounded-full text-2xl text-white flex items-center justify-center
                 bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                      style={{ fontFamily: 'IranSans' }}
                      onClick={fetchEdit}
                    >
                      تایید <TiTick className="ml-3" />
                    </button> */}
                  <button
                    className="w-40 p-2 rounded-full flex items-center justify-center text-[16px] hover:border-2 text-white bg-[#65B741] font-bold 
                  hover:shadow-2xl hover:shadow-black "
                    style={{ fontFamily: 'IranSans' }}
                    onClick={() => Register(editcase)}
                  >
                    ثبت
                    <CiEdit size={30} className="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UsersManagment;
